import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DotOrgNotice = () => {
    return (_jsx("div", { className: "z-modal flex h-30 w-full items-center bg-danger text-center text-info-contrast", children: _jsxs("div", { className: "w-full text-center text-xl font-bold", children: ["app.standardnotes.org is no longer maintained. Please switch to", ' ', _jsx("a", { className: "underline", href: "https://app.standardnotes.com", children: "app.standardnotes.com" })] }) }));
};
export default DotOrgNotice;
